<template>
  <div class="full-indicators-info">
    <table class="full-indicators-info__table">
      <thead>
      <tr>
        <th>Образовательная организация</th>
        <th>Очная форма</th>
        <th>Очно-заочная форма</th>
        <th>Заочная форма</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="!loading">
        <tr v-for="(item) in serverData" :key="calcIdRow(item)">
          <td v-if="item.orgFlag" class="full-indicators-info__table-org" colspan="4">{{ item.regionName }}</td>
          <template v-else>
            <td>
              <a v-if="item.orgName != 'Всего'" @click="openOrg(item)">{{ item.orgName }}</a>
              <span v-else class="full-indicators-info__table-org" style="margin-top: 0 !important;">
                {{ item.orgName }}
              </span>
            </td>
            <td
              @click="openScore(item.id, 1, 1, item.qkcpo, item.kcpGroup.usl.id, item.kcpGroup, item.orgId)"
              class="kcp-percent-scale__stage-one justify-center"
              :class="{'kcp-percent-scale__disabled': item.qkcpo == null}"
            >
              <div class="d-block text-center ww-100 hh-100" style="position: relative">
                <span class="d-flex align-center  justify-center hh-100">{{ showingValue(item, 'qkcpo') }}</span>
                <span class="tooltip-indicators-decline"></span>
              </div>
            </td>
            <td
              @click="openScore(item.id, 1, 2, item.qkcpv, item.kcpGroup.usl.id, item.kcpGroup, item.orgId)"
              class="kcp-percent-scale__stage-one justify-center"
              :class="{'kcp-percent-scale__disabled': item.qkcpv == null}"
            >
              <div
                class="d-block text-center ww-100 hh-100"
                style="position: relative">
                <span class="d-flex align-center  justify-center hh-100">
                  {{ showingValue(item, 'qkcpv') }}
                </span>
                <span class="tooltip-indicators-decline"></span>
              </div>
            </td>
            <td
              @click="openScore(item.id, 1, 3, item.qkcpz, item.kcpGroup.usl.id, item.kcpGroup, item.orgId)"
              class="kcp-percent-scale__stage-one justify-center"
              :class="{'kcp-percent-scale__disabled': item.qkcpz == null}"
            >
              <div
                class="d-block text-center ww-100 hh-100"
                style="position: relative">
                <span class="d-flex align-center  justify-center hh-100">
                  {{ showingValue(item, 'qkcpz') }}
                </span>
                <span class="tooltip-indicators-decline"></span>
              </div>
            </td>
          </template>
        </tr>

      </template>
      <template v-else>
        <tr>
          <td class="full-indicators-info__table-org" rowspan="4" colspan="4">
            <v-progress-linear indeterminate></v-progress-linear>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import {calcBackground} from "@/utils/indicators";
import {getAllGroupedKcpIndicatorsRegion} from "@/api/indicatorsRegion";
import {mapGetters} from "vuex";
// import {mapActions} from "vuex";

export default {
  name: "AllListRegion",
  data() {
    return {
      serverData: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters('keycloak', {
      userId: 'userId',
    }),
  },
  created() {
    // this.getUserInfo();
    this.getServerData();
  },
  methods: {
    // ...mapActions('auth', {getUserInfo: 'getUserInfo', replaceId: 'replaceId'}),
    async getServerData() {
      try {
        this.loading = true;
        this.serverData = await getAllGroupedKcpIndicatorsRegion();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    calcBackground(value, maxValue, minValue = 0) {
      return calcBackground(value, maxValue, minValue)
    },
    showingValue(item, dataField) {
      return item[dataField] == null ? 'нет заявки' : item[dataField]/*.toFixed(3)*/
    },
    calcIdRow(item) {
      return Math.random() + '-' + item.orgId
    },
    openOrg(item) {
      this.$nextTick(() => this.$router.push({
        name: 'AllListStage1Region',
        query: {orgId: item.orgId, regionId: this.userId}
      }));
    },
  },
}
</script>

<style scoped>

</style>